import { render } from "./CloseMenuLogo.vue?vue&type=template&id=a77d02e6"
import script from "./CloseMenuLogo.vue?vue&type=script&lang=js"
export * from "./CloseMenuLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__